import { PermissionRequest } from "@p0security/shared/types/permission";
import React from "react";

import { useSessionHistory } from "../hooks/useSessionHistory";
import { SessionTable } from "./SessionTable";

export const SessionHistoryButton: React.FC<{
  requestId: string;
  requestType: PermissionRequest["type"];
  access?: PermissionRequest["access"];
}> = ({ requestId, requestType, access }) => {
  const session = useSessionHistory(requestId);

  return (
    <SessionTable {...session} requestType={requestType} access={access} />
  );
};
